import { useEffect, useState } from "react";
import { parseSimpleMarkdown } from "../../../../utils/parseMarkDown";

export interface Props {
  text: string;
}

export const IAResponse = ({ text }: Props) => {
  const [textShow, setTextShow] = useState("");

  useEffect(() => {
    let indice = 0;
    let textPrev = "";

    // Función que actualiza el texto gradualmente
    const escribir = () => {
      if (indice <= text.length) {
        textPrev = textPrev + text.charAt(indice);
        setTextShow(textPrev);
        indice++;
      }
    };

    // Establecer el intervalo para la escritura gradual
    const intervalId = setInterval(() => {
      const content = document.getElementById("contentIA");
      escribir();

      if (content) {
        content.scrollTop = content?.scrollHeight;
      }

      if (indice === text.length) {
        clearInterval(intervalId);
      }
    }, 20);

    return () => {
      clearInterval(intervalId);
    };
  }, [text]);

  return (
    <div className="ai-chat__bubble">
      <div className="ai-chat__bubble-avatar">
        <i className="icon icon-ai-bot"></i>
      </div>
      <div
        className="ai-chat__bubble-txt"
        id="contentIA"
        dangerouslySetInnerHTML={{ __html: parseSimpleMarkdown(textShow) }}
      />
    </div>
  );
};
